import { inject, Injectable } from '@angular/core';
import { buildDefaultNavigation } from 'app/core/navigation/navigation.data';
import { Navigation } from 'app/core/navigation/navigation.types';
import { CurrentUserService } from 'app/core/user/current-user.service';
import { Observable, of, ReplaySubject, tap } from 'rxjs';

@Injectable({providedIn: 'root'})
export class NavigationService
{
    private readonly _currentUser = inject(CurrentUserService);
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation>
    {
        return this._navigation.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     *
     * The navigation is defined in the app rather than served by the API, so this
     * resolves locally. It stays an observable because the initial data resolver
     * forkJoins it.
     */
    get(): Observable<Navigation>
    {
        return of<Navigation>({default: buildDefaultNavigation(this._currentUser)}).pipe(
            tap((navigation) =>
            {
                this._navigation.next(navigation);
            }),
        );
    }
}
